/**
 * Mention Parser Utility
 *
 * Extracts @mentions from text and resolves them to user IDs.
 *
 * Supports two mention formats:
 *
 * 1. Structured tokens: @[Display Name](userId)     ← NEW (preferred)
 *    - Inserted by MentionAutocomplete when a user is selected
 *    - Contains the full display name (with spaces) and the userId directly
 *    - No Firestore lookup needed at parse time
 *
 * 2. Legacy plain:    @username
 *    - Created before structured tokens were introduced
 *    - Requires a Firestore lookup to resolve username → userId
 *    - Handled via fallback path for backward compatibility (Phase 6)
 */

// Import all sub-modules for default export (must be at top)
import * as extract from "./extract.js";
import * as resolve from "./resolve.js";
import * as parse from "./parse.js";
import * as format from "./format.js";
import * as validate from "./validate.js";
import * as convert from "./convert.js";

// Re-export all functions from sub-modules
export {
  extractMentions,
  hasMentions,
  extractStructuredMentions,
} from "./extract.js";

export {
  resolveUsernameToId,
  resolveMentionsToUserIds,
} from "./resolve.js";

export {
  parseMentions,
  parseMentionsWithData,
} from "./parse.js";

export {
  formatMentions,
} from "./format.js";

export {
  validateStructuredMentions,
} from "./validate.js";

export {
  convertLegacyMentions,
  getMentionedUserIds,
} from "./convert.js";

// Default export: mentionParser object with all functions
const mentionParser = {
  ...extract,
  ...resolve,
  ...parse,
  ...format,
  ...validate,
  ...convert,
};

export default mentionParser;
